/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Book_BodyInputs */

const en_how_page_book_body = /** @type {(inputs: How_Page_Book_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a service and a free time, then pay in the app or on the day, whichever the coach has set. The confirmation arrives at once.`)
};

const pl_how_page_book_body = /** @type {(inputs: How_Page_Book_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierasz usługę i wolny termin, płacisz w aplikacji albo na miejscu, tak jak ustawi trener. Potwierdzenie przychodzi od razu.`)
};

/**
* | output |
* | --- |
* | "Pick a service and a free time, then pay in the app or on the day, whichever the coach has set. The confirmation arrives at once." |
*
* @param {How_Page_Book_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_book_body = /** @type {((inputs?: How_Page_Book_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Book_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_book_body(inputs)
	return en_how_page_book_body(inputs)
});